export default {"src":"/_next/static/media/dogOutline100_40.2897f5b4.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};